import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import UserGroupDetails from './UserGroupDetails';

const mapStateToProps = state => ({
  userGroup: state.userGroups.details.userGroup,
  isLoading: state.userGroups.details.isLoading,
  failed: state.userGroups.details.failed,
  filters: state.userGroups.list.filters,
  isSamlEnabled: state.authSettings.organization.saml.enabled,
  isAutoProvisioningEnabled: state.authSettings.organization.autoProvisioning.enabled,
});

export default connect(mapStateToProps, null)(
  withTranslation('administration')(UserGroupDetails),
);
